// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanTerminationPropertyDto } from './IPlanTerminationPropertyDto';
import {
    IPlanTerminationPropertyDtoFromJSON,
    IPlanTerminationPropertyDtoFromJSONTyped,
    IPlanTerminationPropertyDtoToJSON,
    IPlanTerminationPropertyDtoToJSONTyped,
} from './IPlanTerminationPropertyDto';

/**
 * 
 * @export
 * @interface IEmployerTerminationPropertiesV3Dto
 */
export interface IEmployerTerminationPropertiesV3Dto {
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesV3Dto
     */
    termination_date: Date;
    /**
     * 
     * @type {Set<IPlanTerminationPropertyDto>}
     * @memberof IEmployerTerminationPropertiesV3Dto
     */
    plans_for_termination?: Set<IPlanTerminationPropertyDto>;
}

/**
 * Check if a given object implements the IEmployerTerminationPropertiesV3Dto interface.
 */
export function instanceOfIEmployerTerminationPropertiesV3Dto(value: object): value is IEmployerTerminationPropertiesV3Dto {
    if (!('termination_date' in value) || value['termination_date'] === undefined) return false;
    return true;
}

export function IEmployerTerminationPropertiesV3DtoFromJSON(json: any): IEmployerTerminationPropertiesV3Dto {
    return IEmployerTerminationPropertiesV3DtoFromJSONTyped(json, false);
}

export function IEmployerTerminationPropertiesV3DtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployerTerminationPropertiesV3Dto {
    if (json == null) {
        return json;
    }
    return {
        
        'termination_date': (new Date(json['termination_date'])),
        'plans_for_termination': json['plans_for_termination'] == null ? undefined : (new Set((json['plans_for_termination'] as Array<any>).map(IPlanTerminationPropertyDtoFromJSON))),
    };
}

export function IEmployerTerminationPropertiesV3DtoToJSON(json: any): IEmployerTerminationPropertiesV3Dto {
    return IEmployerTerminationPropertiesV3DtoToJSONTyped(json, false);
}

export function IEmployerTerminationPropertiesV3DtoToJSONTyped(value?: IEmployerTerminationPropertiesV3Dto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'termination_date': ((value['termination_date']).toISOString()),
        'plans_for_termination': value['plans_for_termination'] == null ? undefined : (Array.from(value['plans_for_termination'] as Set<any>).map(IPlanTerminationPropertyDtoToJSON)),
    };
}

